import React from 'react';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';
import { itemsPerPage } from 'src/data/params';
import ExtendDeal from '../../../components/extend/extendDeal';

import ringAnim from 'src/images/anim/ring.svg';
import SubNavBar from '../../../components/SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiDomainType = '/api/domains/';
const apiDealGet = '/api/deal/';
const linkToDeal = '/dashboard/deal/';
const linkToCustomer = '/dashboard/customer/';
const linkToUser = '/dashboard/user/';

class DealPanorama extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      panelToExtendId: 1,
      isModalExtendedViewOpen: false,
      offsetPanel1: 0,
      offsetPanel2: 0,
      offsetPanel3: 0,
      dealDomain: 1,
      domainTypes: undefined,
      pendingFetch1: false,
      pendingFetch2: false,
      pendingFetch3: false,
      dataDeal1: undefined,
      dataDeal2: undefined,
      dataDeal3: undefined,
      dealFilter1: 0,
      dealFilter2: 0,
      dealFilter3: 0,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.refreshSearch = this.refreshSearch.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.seeMore = this.seeMore.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    this.getDomainTypes();

    this.refreshSearch(1, 0, 0);
    this.refreshSearch(2, 0, 0);
    this.refreshSearch(3, 0, 0);
  }

  getDomainTypes() {
    let queryURL = apiDomainType;
    let graphQL = '{ domains{id, name} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            domainTypes: data['data']['domains'],
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch domain types');
        }.bind(this)
      );
  }

  refreshSearch(panelId, stepIntermediate, offsetNb) {
    let domainFilter = this.state.dealDomain !== '-1' ? `, domainId:${this.state.dealDomain || 1}` : '';

    this.setState({ ['pendingFetch' + panelId]: true }); // toggle loading anim
    let queryURL = apiDealGet;
    let graphQL =
      '{ deals(lost:false, standBy:false, orderBy:dateLastStep, ASC:false' +
      domainFilter +
      ', offset:' +
      itemsPerPage['deal_panorama'] * offsetNb +
      ', limit:' +
      itemsPerPage['deal_panorama'] +
      ' ,stepDeal:' +
      panelId +
      ', stepIntermediate:' +
      stepIntermediate +
      ')' +
      '{ hasMore, items{ id, name, stepNumber, type{ id, name}, creator{ user{ id, username } }, dateCreate, desiredClotureDate, dateLastStep, customer{ id, installationSite{ socialReason } }, type { name }, ' +
      'stepCommercial{ proposition{ pdc } } ' +
      'stepProd{ id, intermediateStageNumber, dealOrder{ salesAssistant{ user{ id, username } } }, preparation{ orderPicker{ user{ id, username } }, installation{ installer{ user{ id, username } } } } }' +
      '} } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['deals']['items']) {
            this.setState({
              ['offsetPanel' + panelId]: offsetNb, // increment or reset the current offset
              ['hasMorePanel' + panelId]: data['data']['deals']['hasMore'],
              ['dataDeal' + panelId]:
                offsetNb > 0
                  ? this.state['dataDeal' + panelId].concat(data['data']['deals']['items'])
                  : data['data']['deals']['items'],
              ['pendingFetch' + panelId]: false,
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch deal list | panel' + panelId + '\n' + error);
        }.bind(this)
      );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.dealFilter1 != this.state.dealFilter1) {
      this.refreshSearch(1, this.state.dealFilter1, 0);
    } else if (prevState.dealFilter2 != this.state.dealFilter2) {
      this.refreshSearch(2, this.state.dealFilter2, 0);
    } else if (prevState.dealFilter3 != this.state.dealFilter3) {
      this.refreshSearch(3, this.state.dealFilter3, 0);
    } else if (prevState.dealDomain !== this.state.dealDomain) {
      this.refreshSearch(1, this.state.dealFilter1, 0);
      this.refreshSearch(2, this.state.dealFilter2, 0);
      this.refreshSearch(3, this.state.dealFilter3, 0);
    }
  }

  seeMore(type) {
    switch (type) {
      case 'deal1':
        this.refreshSearch(1, this.state.dealFilter1, this.state.offsetPanel1 + 1);
        break;
      case 'deal2':
        this.refreshSearch(2, this.state.dealFilter2, this.state.offsetPanel2 + 1);
        break;
      case 'deal3':
        this.refreshSearch(3, this.state.dealFilter3, this.state.offsetPanel3 + 1);
        break;
    }
  }

  handleDomainChange = (event) => {
    const target = event.target;
    const value = target.value;

    this.setState({ dealDomain: value });
  };

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  getRowColor(deal) {
    let res = 'transparent';
    let step = deal.stepProd.intermediateStageNumber;
    switch (step) {
      case 1:
        res = '#860000';
        break;
      case 2:
        res = '#FF7A3C';
        break;
      case 3:
        res = '#47D761';
        break;
    }

    return res;
  }

  render() {
    const { dataDeal1 } = this.state;
    const { dataDeal2 } = this.state;
    const { dataDeal3 } = this.state;

    let noDeal1 =
      this.state.dataDeal1 != undefined && this.state.dataDeal1.length == 0 ? <span>Aucun résultat.</span> : '';
    let noDeal2 =
      this.state.dataDeal2 != undefined && this.state.dataDeal2.length == 0 ? <span>Aucun résultat.</span> : '';
    let noDeal3 =
      this.state.dataDeal3 != undefined && this.state.dataDeal3.length == 0 ? <span>Aucun résultat.</span> : '';

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
          goBack={this.props.history.goBack}
          appViewNavExtended={this.state.appViewNavExtended}
          title='Affaires'
        />

        <div id='appViewContent'>
          <div className='panel-versatile panorama deal'>
            <div className='panel-versatile-header alignHorizontal'>
              <h5>Commercial</h5>
              {this.state.domainTypes && (
                <select value={this.state.dealDomain} onChange={this.handleDomainChange} className='form-control'>
                  {this.state.domainTypes.map((type, key) => (
                    <option value={type.id} key={key}>
                      {type.name}
                    </option>
                  ))}
                  <option value={-1} key='All'>
                    Tout afficher
                  </option>
                </select>
              )}

              <select
                name='dealFilter1'
                value={this.state.dealFilter1}
                onChange={this.handleInputChange}
                className='form-control'
                id='exampleSelect1'
              >
                <option value={0}>Tous</option>
                <option value={1}>Proposition</option>
                <option value={2}>BDC</option>
                <option value={3}>Dossier Prod</option>
              </select>
              <button
                onClick={() => this.refreshSearch(1, this.state.dealFilter1, 0)}
                type='button'
                className='btn btn-sm btn-outline-success'
              >
                <span className='icon icon-cw' />
              </button>
              <div onClick={() => this.openModal('extendedView-1')} className={'float-button'}>
                <span className={'icon icon-magnifying-glass'} />
              </div>
              {this.state.pendingFetch1 && (
                <div className='alignHorizontal'>
                  <img src={ringAnim} />
                </div>
              )}
            </div>
            <div className='panel-versatile-header panel-versatile-th alignHorizontal'>
              <span>Nom</span>
              <span>Client</span>
              <span>Type</span>
              <span>Créateur</span>
            </div>
            <div className='panel-versatile-body'>
              {dataDeal1 ? (
                dataDeal1.map((data, i) => (
                  <li
                    key={data.id}
                    className={'list-group-item panorama-deal-row ' + (i % 2 !== 0 ? 'highlighted ' : '')}
                  >
                    <Link to={linkToDeal + data.id}>
                      <span title={data.name}>{data.name} </span>
                    </Link>
                    <Link to={linkToCustomer + data.customer.id}>
                      <span title={data.customer.installationSite.socialReason}>
                        {data.customer.installationSite.socialReason}
                      </span>
                    </Link>
                    <span>{data.type.name}</span>
                    <Link to={linkToUser + data.creator.user.id}>
                      <span>{data.creator.user.username}</span>
                    </Link>
                  </li>
                ))
              ) : (
                <li className='list-group-item'>Chargement...</li>
              )}
              {this.state.hasMorePanel1 && (
                <div className='list-see-more'>
                  {this.state.pendingFetch1 ? (
                    <img src={ringAnim} />
                  ) : (
                    <button
                      onClick={() => this.seeMore('deal1')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className=''>Voir plus</span>
                    </button>
                  )}
                </div>
              )}
              {noDeal1}
            </div>
          </div>
          <div className='panel-versatile panorama deal'>
            <div className='panel-versatile-header alignHorizontal'>
              <h5>Production</h5>
              {this.state.domainTypes && (
                <select value={this.state.dealDomain} onChange={this.handleDomainChange} className='form-control'>
                  {this.state.domainTypes.map((type, key) => (
                    <option value={type.id} key={key}>
                      {type.name}
                    </option>
                  ))}
                  <option value={-1} key='All'>
                    Tout afficher
                  </option>
                </select>
              )}

              <select
                name='dealFilter2'
                value={this.state.dealFilter2}
                onChange={this.handleInputChange}
                className='form-control'
                id='exampleSelect1'
              >
                <option value={0}>Tous</option>
                <option value={1}>Commande</option>
                <option value={2}>Préparation</option>
                <option value={3}>Installation</option>
              </select>
              <button
                onClick={() => this.refreshSearch(2, this.state.dealFilter2, 0)}
                type='button'
                className='btn btn-sm btn-outline-success'
              >
                <span className='icon icon-cw' />
              </button>
              <div onClick={() => this.openModal('extendedView-2')} className={'float-button'}>
                <span className={'icon icon-magnifying-glass'} />
              </div>
              {this.state.pendingFetch2 && (
                <div className='alignHorizontal'>
                  <img src={ringAnim} />
                </div>
              )}
            </div>
            <div className='panel-versatile-header panel-versatile-th alignHorizontal'>
              <span>Nom</span>
              <span>Client</span>
              <span>Type</span>
              <span>Créateur</span>
            </div>
            <div className='panel-versatile-body'>
              {dataDeal2 ? (
                dataDeal2.map((data, i) => (
                  <li
                    key={data.id}
                    className={'list-group-item panorama-deal-row ' + (i % 2 !== 0 ? 'highlighted ' : '')}
                    style={{
                      borderLeft: data.stepNumber !== 2 ? 'inherit' : '10px solid ' + this.getRowColor(data),
                    }}
                  >
                    <Link to={linkToDeal + data.id}>
                      <span title={data.name}>{data.name} </span>
                    </Link>
                    <Link to={linkToCustomer + data.customer.id}>
                      <span title={data.customer.installationSite.socialReason}>
                        {data.customer.installationSite.socialReason}
                      </span>
                    </Link>
                    <span>{data.type.name}</span>
                    <Link to={linkToUser + data.creator.user.id}>
                      <span>{data.creator.user.username}</span>
                    </Link>
                  </li>
                ))
              ) : (
                <li className='list-group-item'>Chargement...</li>
              )}
              {this.state.hasMorePanel2 && (
                <div className='list-see-more'>
                  {this.state.pendingFetch2 ? (
                    <img src={ringAnim} />
                  ) : (
                    <button
                      onClick={() => this.seeMore('deal2')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className=''>Voir plus</span>
                    </button>
                  )}
                </div>
              )}
              {noDeal2}
            </div>
          </div>
          <div className='panel-versatile panorama deal'>
            <div className='panel-versatile-header alignHorizontal'>
              <h5>Administratif</h5>
              {this.state.domainTypes && (
                <select value={this.state.dealDomain} onChange={this.handleDomainChange} className='form-control'>
                  {this.state.domainTypes.map((type, key) => (
                    <option value={type.id} key={key}>
                      {type.name}
                    </option>
                  ))}
                  <option value={-1} key='All'>
                    Tout afficher
                  </option>
                </select>
              )}
              <select
                name='dealFilter3'
                value={this.state.dealFilter3}
                onChange={this.handleInputChange}
                className='form-control'
                id='exampleSelect1'
              >
                <option value={0}>Tous</option>
                <option value={1}>A facturer</option>
                <option value={2}>Partiellement facturé</option>
              </select>
              <button
                onClick={() => this.refreshSearch(3, this.state.dealFilter3, 0)}
                type='button'
                className='btn btn-sm btn-outline-success'
              >
                <span className='icon icon-cw' />
              </button>
              <div onClick={() => this.openModal('extendedView-3')} className={'float-button'}>
                <span className={'icon icon-magnifying-glass'} />
              </div>
              {this.state.pendingFetch3 && (
                <div className='alignHorizontal'>
                  <img src={ringAnim} />
                </div>
              )}
            </div>
            <div className='panel-versatile-header panel-versatile-th alignHorizontal'>
              <span>Nom</span>
              <span>Client</span>
              <span>Type</span>
              <span>Créateur</span>
            </div>
            <div className='panel-versatile-body'>
              {dataDeal3 ? (
                dataDeal3.map((data, i) => (
                  <li
                    key={data.id}
                    className={'list-group-item panorama-deal-row ' + (i % 2 !== 0 ? 'highlighted ' : '')}
                  >
                    <Link to={linkToDeal + data.id}>
                      <span title={data.name}>{data.name} </span>
                    </Link>
                    <Link to={linkToCustomer + data.customer.id}>
                      <span title={data.customer.installationSite.socialReason}>
                        {data.customer.installationSite.socialReason}
                      </span>
                    </Link>
                    <span>{data.type.name}</span>
                    <Link to={linkToUser + data.creator.user.id}>
                      <span>{data.creator.user.username}</span>
                    </Link>
                  </li>
                ))
              ) : (
                <li className='list-group-item'>Chargement...</li>
              )}
              {this.state.hasMorePanel3 && (
                <div className='list-see-more'>
                  {this.state.pendingFetch3 ? (
                    <img src={ringAnim} />
                  ) : (
                    <button
                      onClick={() => this.seeMore('deal3')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className=''>Voir plus</span>
                    </button>
                  )}
                </div>
              )}
              {noDeal3}
            </div>
          </div>

          <ExtendDeal
            parentDealState={this.state.panelToExtendId}
            isOpen={this.state.isModalExtendedViewOpen}
            onClose={this.closeModal}
          />
        </div>
      </div>
    );
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalExtendedViewOpen: false,
    });
  }

  openModal(type) {
    let toOpen = undefined;
    switch (type) {
      case 'extendedView-1':
      case 'extendedView-2':
      case 'extendedView-3':
        this.setState({
          panelToExtendId: parseInt(type.split('-')[1]),
        });
        toOpen = 'isModalExtendedViewOpen';
        break;
    }
    this.props.toggleBlackOut();
    this.setState({
      [toOpen]: true,
      appViewNavExtended: false,
    });
  }
}

export default withAuth(DealPanorama);
